(() => {
  const COOKIE = 'lola_region';
  const country = window.Shopify?.country;

  // Enlace directo ?region=canarias|peninsula: solo vale en el mercado España (/{idioma}-es), sea cual sea el idioma
  const url = new URL(window.location.href);
  const regionParam = url.searchParams.get('region');
  const isSpainUrl = /^\/[a-z]{2}(?:-[a-z]{2})?-es(?:\/|$)/i.test(url.pathname);
  if (regionParam && isSpainUrl && (!country || country === 'ES') && ['canarias', 'peninsula'].includes(regionParam)) {
    document.cookie = regionParam === 'canarias'
      ? `${COOKIE}=canarias; path=/; max-age=31536000; SameSite=Lax`
      : `${COOKIE}=; path=/; max-age=0; SameSite=Lax`;
    url.searchParams.delete('region');
    window.history.replaceState(window.history.state, '', url.toString());
  }

  let isCanarias = new RegExp(`(?:^|;\\s*)${COOKIE}=canarias(?:;|$)`).test(document.cookie);

  // Canarias solo existe dentro del mercado España
  if (isCanarias && country && country !== 'ES') {
    document.cookie = `${COOKIE}=; path=/; max-age=0; SameSite=Lax`;
    isCanarias = false;
  }

  // Vacío = agotado para variantes; parseStock (null) solo evita ocultar cards sin sincronizar
  const parseStock = (value) => (value === '' || value === null || value === undefined ? null : Number(value));
  const parsePdpStock = (value) => (value === '' || value === null || value === undefined ? 0 : Number(value));
  const isSoldOut = (stock) => stock !== null && !Number.isNaN(stock) && stock <= 0;

  // Se carga antes de global.js para que las product-card ya lean las variantes con el stock de Canarias
  window.LolaRegion = {
    isCanarias,
    showSoldOutProducts: document.currentScript?.dataset.showSoldOut === 'true',
    adjustVariants(variants) {
      if (!isCanarias || !Array.isArray(variants)) return variants;
      return variants.map((variant) => {
        const stock = parsePdpStock(variant.canarias_stock);
        if (Number.isNaN(stock)) return variant;
        return { ...variant, available: Boolean(variant.available) && stock > 0, inventory_quantity: stock };
      });
    },
    isAvailableInCanarias(variants) {
      if (!isCanarias || this.showSoldOutProducts || !Array.isArray(variants) || variants.length === 0) return true;
      const stocks = variants.map((variant) => parseStock(variant.canarias_stock));
      if (stocks.some((stock) => stock === null || Number.isNaN(stock))) return true;
      return variants.some((variant, index) => Boolean(variant.available) && stocks[index] > 0);
    },
  };

  if (!isCanarias) return;

  document.documentElement.classList.add('is-region-canarias');

  const markSelector = () => {
    document.querySelectorAll('[data-region-summary]').forEach((summary) => {
      if (summary.dataset.canariasLabel) summary.textContent = summary.dataset.canariasLabel;
    });
    document.querySelectorAll('[data-region-peninsula-item]').forEach((item) => item.classList.remove('is-active'));
    document.querySelectorAll('[data-region-canarias-item]').forEach((item) => item.classList.add('is-active'));
  };

  const getStockMap = () => {
    const script = document.querySelector('[data-canarias-stock-map]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent) || {};
    } catch (_) {
      return {};
    }
  };

  const applyToOptions = () => {
    document.querySelectorAll('input[data-canarias-stock]').forEach((input) => {
      const soldOut = isSoldOut(parsePdpStock(input.dataset.canariasStock));
      input.classList.toggle('disabled', soldOut);
      input.closest('li')?.classList.toggle('disabled', soldOut);
    });
  };

  const applyToBuyButtons = () => {
    const stockMap = getStockMap();
    document.querySelectorAll('product-form').forEach((productForm) => {
      const variantId = productForm.querySelector('[name="id"]')?.value;
      if (!variantId || typeof productForm.toggleSubmitButton !== 'function') return;
      if (isSoldOut(parsePdpStock(stockMap[variantId]))) {
        productForm.toggleSubmitButton(true, window.variantStrings?.soldOut);
      }
    });
  };

  const applyProductStock = () => {
    applyToOptions();
    applyToBuyButtons();
  };

  const init = () => {
    markSelector();
    applyProductStock();
    // El theme reactiva el botón al cambiar de variante y publica este evento justo después
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, applyProductStock);
    }
  };

  // DOMContentLoaded llega tras ejecutarse todos los scripts defer, incluido el que define product-form
  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
